import * as React from 'react'
import Select from 'react-select'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { API } from '@getgreenline/homi-shared'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { FormError } from '../../../../../components/FormError'

export type Mode = 'cash drop' | 'pay in' | 'pay out'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  onSubmit: () => void
  onHide: () => void
}

interface State {
  isSaving: boolean
  locationId?: number
  errorMessage?: string
}

@inject('currentCompanyStore')
@observer
export class CreateInventorySnapshotModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isSaving: false,
    }
  }

  componentDidMount() {
    this.props.currentCompanyStore!.getLocations()
  }

  save() {
    if (this.state.locationId) {
      const company = this.props.currentCompanyStore!.company!
      this.setState({ isSaving: true })
      API.createInventorySnapshot(company.id, this.state.locationId)
        .then(() => {
          this.props.onSubmit()
        })
        .catch((error) => {
          this.setState({ isSaving: false })
          this.setState({ errorMessage: error.response.data.message })
        })
    }
  }

  onHide() {
    this.props.onHide()
  }

  render() {
    const locations = this.props.currentCompanyStore!.locations || []

    let saveButton: JSX.Element
    if (this.state.isSaving) {
      saveButton = (
        <button className='btn btn-lg btn-success w-100' disabled>
          Updating...
        </button>
      )
    } else if (this.state.locationId) {
      saveButton = (
        <button className='btn btn-lg btn-success w-100' disabled>
          Location required
        </button>
      )
    } else {
      saveButton = (
        <button
          className='btn btn-lg btn-success w-100'
          onClick={(e) => {
            e.preventDefault()
            this.save()
          }}
        >
          Create
        </button>
      )
    }

    return (
      <Modal isOpen={true} toggle={() => this.onHide()}>
        <ModalHeader toggle={() => this.onHide()}>
          <span>Create a new inventory snapshot</span>
        </ModalHeader>
        <ModalBody>
          <div className='form-group'>
            <label>Location</label>
            <Select
              clearable={true}
              value={this.state.locationId}
              options={locations.map((location) => {
                return {
                  value: location.id,
                  label: location.name,
                }
              })}
              onChange={(option: { label: string; value: number } | null) => {
                if (!option) {
                  this.setState({ locationId: undefined })
                } else {
                  this.setState({ locationId: option.value })
                }
              }}
            />
          </div>
          <div className='form-group'>
            <button className='btn btn-success w-100' onClick={() => this.save()}>
              Create
            </button>
          </div>
        </ModalBody>
      </Modal>
    )
  }
}
